import React from 'react'
import OllieAskLink from 'src/components/ollie/OllieAskLink'
import useOllieVenueId from 'src/hooks/useOllieVenueId'
import { trackOllieContextualAskOpened } from 'src/utils/ollieDiscoverability'
import { STOCK_TAKE_ASK_OLLIE_QUIET_LABEL } from 'src/utils/stockTakeHud'

const StockTakeAskOllie = ({
  loaded = false,
  afterSavedCount = false,
  askOllie = null,
  onOpen,
  toolbar = false,
}) => {
  const { venueId } = useOllieVenueId()
  if (!loaded) return null
  const question = afterSavedCount ? askOllie?.question : undefined
  const label = afterSavedCount
    ? askOllie?.label || 'Ask Ollie about this stock take'
    : STOCK_TAKE_ASK_OLLIE_QUIET_LABEL
  return (
    <OllieAskLink
      data-testid='stock-take-ask-ollie'
      quiet={!afterSavedCount}
      toolbar={toolbar}
      openEmpty={!afterSavedCount}
      label={label}
      question={question}
      onOpen={() => {
        trackOllieContextualAskOpened({
          venueId,
          entryPoint: afterSavedCount ? 'stock_take_after_count' : 'stock_take',
          page: 'stock',
          question: question || label,
        })
        if (typeof onOpen === 'function') onOpen()
      }}
    />
  )
}

export default StockTakeAskOllie
